/*
  Vadora product card — Add to cart on the collection + search grids.
  One delegated listener (module scripts run once per page), so it keeps working
  after the base theme re-renders the grid for filtering, sorting and pagination.
*/
if (!window.__vadoraPcard) {
  window.__vadoraPcard = true;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[data-pcard-form]') : null;
    if (!form || !window.fetch) return; // no fetch: let the form submit normally
    e.preventDefault();

    var btn = form.querySelector('.pcard__add');
    var label = btn && btn.querySelector('span');
    var original = label ? label.textContent : '';
    if (label) label.textContent = 'Adding…';
    if (btn) btn.disabled = true;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (label) label.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer-component, cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else window.location.href = root + 'cart';
        setTimeout(function () { if (label) label.textContent = original; if (btn) btn.disabled = false; }, 2500);
      })
      .catch(function () { form.submit(); });
  });
}
